import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import "../Components/dashboardpage.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import CircularProgress from "@mui/material/CircularProgress";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";
import { PolarArea } from "react-chartjs-2";
import { RadialLinearScale } from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  RadialLinearScale,
  Legend
);

const DashboardChart = () => {
  // ================= STATE =================

  const [bookings, setBookings] = useState([]);
  const [cars, setCars] = useState([]);
  const [users, setUsers] = useState([]);
 const [loading, setLoading] = useState(false);
  const [carTypeChart, setCarTypeChart] = useState({
    labels: [],
    values: [],
  });

  const [tripTypeChart, setTripTypeChart] = useState({
    labels: [],
    values: [],
  });

  const [revenueChart, setRevenueChart] = useState({
    labels: [],
    values: [],
  });

  const [carsChart, setCarsChart] = useState({
    labels: [],
    values: [],
  });

  // const [usersChart, setUsersChart] = useState({
  //   labels: [],
  //   values: [],
  // });

  // const [monthlyChart, setMonthlyChart] = useState({
  //   labels: [],
  //   values: [],
  // });

  // ================= FETCH FIREBASE DATA =================

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)

        // BOOKINGS
        const bookingSnapshot = await getDocs(
          collection(db, "bookings")
        );

        const bookingData = bookingSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setBookings(bookingData);

        // CARS
        const carsSnapshot = await getDocs(collection(db, "bookings"));

        const carsData = carsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setCars(carsData);

        // USERS
        const usersSnapshot = await getDocs(
          collection(db, "users")
        );

        const usersData = usersSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setUsers(usersData);

      } catch (error) {
        console.log("Firebase Error:", error);
      }
      finally {
    setLoading(false);
  }
    };

    fetchData();
  }, []);

  // ================= PROCESS CHART DATA =================

  useEffect(() => {
    // ================= BOOKINGS =================

    const carMap = {};
    const revenueMap = {};
    const tripMap = {};
    const monthMap = {};

    bookings.forEach((b) => {
      const carType = b.carType || "Unknown";
      const tripType = b.tripType || "Unknown";
      const price = Number(b.carPrice || 0);

      // CAR TYPE BOOKINGS
      carMap[carType] = (carMap[carType] || 0) + 1;

      // REVENUE
      revenueMap[carType] =
        (revenueMap[carType] || 0) + price;

      // TRIP TYPE
      tripMap[tripType] = (tripMap[tripType] || 0) + 1;

      // MONTHLY BOOKINGS
      if (b.createdAt) {
        const date = b.createdAt.toDate();

        const month = date.toLocaleString("default", {
          month: "short",
        });

        monthMap[month] = (monthMap[month] || 0) + 1;
      }
    });

    setCarTypeChart({
      labels: Object.keys(carMap),
      values: Object.values(carMap),
    });

    setRevenueChart({
      labels: Object.keys(revenueMap),
      values: Object.values(revenueMap),
    });

    setTripTypeChart({
      labels: Object.keys(tripMap),
      values: Object.values(tripMap),
    });

    // setMonthlyChart({
    //   labels: Object.keys(monthMap),
    //   values: Object.values(monthMap),
    // });

    // ================= CARS =================

    const carsMap = {};

    cars.forEach((car) => {
      const type = car.carType || "Unknown";

      carsMap[type] = (carsMap[type] || 0) + 1;
    });

    setCarsChart({
      labels: Object.keys(carsMap),
      values: Object.values(carsMap),
    });

    // ================= USERS =================

    // setUsersChart({
    //   labels: ["Users"],
    //   values: [users.length],
    // });

  }, [bookings, cars, users]);

  // ================= TOTAL REVENUE =================

  const totalRevenue = bookings.reduce(
    (acc, b) => acc + Number(b.carPrice || 0),
    0
  );
// 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
    <div className="DashboardApp">

      {/* ================= TOP CARDS ================= */}

      <div className="topCards">

        <div
          className="card"
          style={{ background: "#4CAF50" }}
        >
          <h4>Total Bookings</h4>
          <p>{bookings.length}</p>
        </div>

        <div
          className="card"
          style={{ background: "#2196F3" }}
        >
          <h4>Total Revenue</h4>
          <p>SAR {totalRevenue}</p>
        </div>

        <div
          className="card"
          style={{ background: "#FF9800" }}
        >
          <h4>Total Cars</h4>
          <p>{cars.length}</p>
        </div>

        <div
          className="card"
          style={{ background: "#9C27B0" }}
        >
          <h4>Registered Users</h4>
          <p>{users.length}</p>
        </div>

      </div>

      {/* ================= BOOKINGS BY CAR TYPE ================= */}

      <div className="dataCard">
        <Bar
          data={{
            labels: carTypeChart.labels,
            datasets: [
              {
                label: "Bookings",
                data: carTypeChart.values,
                backgroundColor: [
                  "#4CAF50",
                  "#FF9800",
                  "#2196F3",
                  "#9C27B0",
                ],
                borderRadius: 8,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
              title: {
                display: true,
                text: "Bookings by Car Type",
              },
            },
          }}
        />
      </div>

      {/* ================= TRIP TYPE ================= */}

      <div className="dataCard">
        <Doughnut
          data={{
            labels: tripTypeChart.labels,
            datasets: [
              {
                data: tripTypeChart.values,
                backgroundColor: [
                  "#4CAF50",
                  "#FF9800",
                  "#2196F3",
                ],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
              title: {
                display: true,
                text: "Trip Type Distribution",
              },
            },
          }}
        />
      </div>

      {/* ================= REVENUE ================= */}

      <div className="dataCard">
        <Bar
          data={{
            labels: revenueChart.labels,
            datasets: [
              {
                label: "Revenue",
                data: revenueChart.values,
                backgroundColor: [
                  "#4CAF50",
                  "#2196F3",
                  "#FF9800",
                  "#9C27B0",
                ],
                borderRadius: 10,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
              legend: {
                display: false,
              },

              title: {
                display: true,
                text: "Revenue by Car Type",
              },
            },

            scales: {
              y: {
                beginAtZero: true,

                ticks: {
                  callback: function (value) {
                    return "SAR " + value;
                  },
                },
              },
            },
          }}
        />
      </div>

      {/* ================= AVAILABLE CARS ================= */}

      <div className="dataCard">
        <Doughnut
          data={{
            labels: carsChart.labels,
            datasets: [
              {
                data: carsChart.values,
                backgroundColor: [
                  "#4CAF50",
                  "#2196F3",
                  "#FF9800",
                  "#9C27B0",
                ],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
              title: {
                display: true,
                text: "Available Cars by Type",
              },
            },
          }}
        />
      </div>

      {/* ================= USERS ================= */}

      {/* ================= USERS CHART ================= */}

      <div className="dataCard">
        <Bar
          data={{
            labels: users.map((user) => user.name || "Unknown"),

            datasets: [
              {
                label: "Registered Users",

                data: users.map(() => 1),

                backgroundColor: [
                  "#2196F3",
                  "#4CAF50",
                  "#FF9800",
                  "#9C27B0",
                  "#E91E63",
                  "#00BCD4",
                ],

                borderRadius: 10,
                barThickness: 40,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
              legend: {
                display: false,
              },

              title: {
                display: true,
                text: "Registered Users Names",
                font: {
                  size: 18,
                  weight: "bold",
                },
              },
            },

            scales: {
              x: {
                ticks: {
                  color: "#555",

                  font: {
                    size: 12,
                  },
                },

                grid: {
                  display: false,
                },
              },

              y: {
                beginAtZero: true,

                ticks: {
                  stepSize: 1,
                },

                grid: {
                  color: "#eee",
                },
              },
            },
          }}
        />
      </div>
      {/* ================= MONTHLY BOOKINGS ================= */}



      <div className="dataCard">
        <PolarArea
          data={{
            labels: [
              "Bookings",
              "Cars",
              "Users",
              "Revenue (K)",
            ],

            datasets: [
              {
                label: "Overview",

                data: [
                  bookings.length,
                  cars.length,
                  users.length,
                  totalRevenue / 1000,
                ],

                backgroundColor: [
                  "#4CAF50",
                  "#2196F3",
                  "#FF9800",
                  "#9C27B0",
                ],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
              title: {
                display: true,
                text: "System Overview (Polar View)",
              },

              legend: {
                position: "right",
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default DashboardChart;